export const titleTruncate = (
  title: string,
  total: number,
  options: { channelMembersCount: string; displayRemainingCount: boolean } = {
    channelMembersCount: '',
    displayRemainingCount: false,
  }
) => {
  if (!title) return title;

  if (title.length > total) {
    const truncated = title.substring(0, total - 3);
    // Count visible members by counting commas in truncated string
    const visibleMembersCount = (truncated.match(/,/g) || []).length + 1;

    // Extract total member count from channelMembersCount string (e.g., "5 Members" or "ABC123 · 5 Members")
    const totalMatch = options.channelMembersCount.match(/(\d+)\s+Members/);
    const totalMembers = totalMatch ? parseInt(totalMatch[1], 10) : 0;

    const remainingCount = totalMembers - visibleMembersCount;

    return `${truncated}...${options.displayRemainingCount && remainingCount > 0 ? `+${remainingCount + 1}` : ''}`;
  }

  return title;
};
